import Vue from "vue";
import Router from "vue-router";
import HsyDemo from "@/views/wasm/index";
import MonitoringVideoPlayback from "@/views/monitoringVideoPlayback/index";
import FlvDemo from "@/views/flvDemo/index";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "*",
      redirect: "/",
    },
    {
      path: "/",
      name: "PageView",
      component: (resolve) => require(["@/views/PageView"], resolve),
      children: [
        {
          path: "/",
          redirect: "/home",
        },
        {
          path: "/home",
          name: "home",
          component: (resolve) => require(["@/views/HomePage"], resolve),
          meta: {
            title: "采寻网络科技（杭州）有限公司",
          },
        },
        {
          path: "/ProductCenter",
          name: "ProductCenter",
          component: (resolve) => require(["@/views/ProductCenter"], resolve),
          meta: {
            title: "产品中心",
          },
        },
        {
          path: "/ProductDetail/:index1/:index2",
          name: "ProductDetail",
          component: (resolve) => require(["@/views/ProductDetail"], resolve),
          meta: {
            title: "产品详情",
          },
        },
        {
          path: "/CustomesExample",
          name: "CustomesExample",
          component: (resolve) => require(["@/views/CustomesExample"], resolve),
          meta: {
            title: "客户案例",
          },
        },
        {
          path: "/answer",
          name: "answer",
          component: (resolve) => require(["@/views/answer"], resolve),
          meta: {
            title: "解决方案",
          },
        },
        {
          path: "/ExampleDetail/:index",
          name: "ExampleDetail",
          component: (resolve) => require(["@/views/ExampleDetail"], resolve),
          meta: {
            title: "案例详情",
          },
        },
        {
          path: "/JoinUs",
          name: "JoinUs",
          component: (resolve) => require(["@/views/JoinUs"], resolve),
          meta: {
            title: "加入我们",
          },
        },
        {
          path: "/VideoTutorial",
          name: "VideoTutorial",
          component: (resolve) => require(["@/views/VideoTutorial"], resolve),
          meta: {
            title: "视频教程",
          },
        },
        {
          path: "/videoDetail",
          name: "videoDetail",
          component: (resolve) => require(["@/views/videoDetail"], resolve),
          meta: {
            title: "视频详情",
          },
        },
        {
          path: "/AboutUs",
          name: "AboutUs",
          component: (resolve) => require(["@/views/AboutUs"], resolve),
          meta: {
            title: "公司简介",
          },
        },
        {
          path: "/ContactUs",
          name: "ContactUs",
          component: (resolve) => require(["@/views/ContactUs"], resolve),
          meta: {
            title: "联系我们",
          },
        },
        // {
        //   path: '/Echarts',
        //   name: 'Echarts',
        //   component: resolve => require(['@/views/Echarts'], resolve),
        //   meta: {
        //     title: '图表'
        //   }
        // },
      ],
    },
    {
      path: "/hsyDemo",
      name: "HsyDemo",
      component: HsyDemo,
      meta: {
        title: "慧视云demo",
      },
    },
    {
      path: "/monitoringVideoPlayback",
      name: "MonitoringVideoPlayback",
      component: MonitoringVideoPlayback,
      meta: {
        title: "录像播放",
      },
    },
    {
      path: "/flvDemo",
      name: "FlvDemo",
      component: FlvDemo,
      meta: {
        title: "记录查看",
      },
    },
  ],
});
